import React from 'react'
import TextField from '@material-ui/core/TextField'
import SearchIcon from '@material-ui/icons/Search'
import { useFormik } from 'formik'
import InputAdornment from '@material-ui/core/InputAdornment'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useTheme } from '@material-ui/core/styles'
import { TranslationDictionary, useDisclosure } from '@plandi/common'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import DialogContent from '@material-ui/core/DialogContent'
import Badge from '@material-ui/core/Badge'
import { ReactComponent as FilterIcon } from '../../assets/icons/filterIcon.svg'

import { useSearchBarStylesNew } from './search-bar-new.styles'
import { useSearchParam } from './use-search-param'

type SearchBarNewProps = {
  withButton?: boolean
  className?: string
  sticky?: boolean
  onSubmit?: (value?: string) => void
  onClear?: () => void
  invisibleBadge?: boolean
  searchType?: string
  translate?: TranslationDictionary['data']
}

export const SearchBarNew: React.FC<SearchBarNewProps> = (props) => {
  const classes = useSearchBarStylesNew()
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))

  const { keyword, setSearchParam } = useSearchParam()

  const { isOpen, onOpen, onClose } = useDisclosure()

  const formik = useFormik({
    initialValues: {
      keyword: keyword ?? ''
    },
    enableReinitialize: true,
    onSubmit: (value) => {
      props.onSubmit?.(value.keyword)

      setSearchParam(value.keyword)
    }
  })

  const handleClear = () => {
    formik.setFieldValue('keyword', '')

    setSearchParam(undefined)

    props.onClear?.()
  }

  const hasKeywordValue = formik.values.keyword.length > 0

  return (
    <form onSubmit={formik.handleSubmit} className={classes.root}>
      <TextField
        value={formik.values.keyword}
        onChange={formik.handleChange}
        name="keyword"
        className={classes.inputSearch}
        fullWidth
        placeholder={props.translate?.['job-site']['adverts-page']['search']}
        size="small"
        variant="outlined"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon color="primary" />
            </InputAdornment>
          ),
          classes: { notchedOutline: classes.noBorder },
          endAdornment: (
            <>
              {hasKeywordValue && (
                <InputAdornment
                  position="start"
                  onClick={handleClear}
                  className={classes.action}
                >
                  <CloseIcon color="action" />
                </InputAdornment>
              )}
              {!isDesktop && (
                <InputAdornment
                  position="start"
                  onClick={onOpen}
                  className={classes.action}
                >
                  <Badge color="secondary" invisible={props.invisibleBadge}>
                    <FilterIcon />
                  </Badge>
                </InputAdornment>
              )}
            </>
          )
        }}
      />

      {isOpen && !isDesktop && (
        <Dialog
          open={isOpen}
          onClose={onClose}
          fullScreen
          className={props.searchType === 'models' ? classes.dialogModal : ''}
        >
          {props.searchType !== 'models' && (
            <DialogActions>
              <IconButton onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </DialogActions>
          )}
          <DialogContent
            className={
              props.searchType === 'models' ? classes.dialogContent : ''
            }
          >
            {props.children}
          </DialogContent>
        </Dialog>
      )}
    </form>
  )
}
